import { render, staticRenderFns } from "./WaveCell.vue?vue&type=template&id=649f1ba8&scoped=true&"
import script from "./WaveCell.vue?vue&type=script&lang=js&"
export * from "./WaveCell.vue?vue&type=script&lang=js&"
import style0 from "./WaveCell.vue?vue&type=style&index=0&id=649f1ba8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649f1ba8",
  null
  
)

export default component.exports